module.exports = "<div *ngIf=\"!isEditing\" class=\"thought-long-text-display\" [innerHTML]=\"field.value\"></div>\r\n<app-tiny-editor \r\n    *ngIf=\"isEditing\"\r\n    elementId=\"text-editor-{{id}}\"\r\n    [ready]=\"ready\"\r\n    [richText]=\"field.value\"\r\n    (onEditorKeyup)=\"updateRichTextField($event)\"\r\n    class=\"long-text-editor\"></app-tiny-editor>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/long-text/long-text.component.html
// module id = ../../../../../src/app/thought-module/field/long-text/long-text.component.html
// module chunks = main